import {useState} from "react"
import {apiTranslation} from "./Api"
import {useFlag} from "./Flag"
import {localDateOptions, localDateTimeOptions, localLangDefault, localFormatCurrency, localFormatCurrencyShort, localFormatDecimal, localTranslationMissingPrefix, localLangList} from "../settings"
import translationData from "../translation.json"

export const useLocal = () => {
    const langFlag = useFlag(localLangDefault, "lang")
    const [state, setState] = useState({
        app: translationData,
        api: null,
    })

    const load = async () => {
        const translations = await apiTranslation()
        setState(prevState => ({...prevState, api: translations}))
    }

    const setLang = (code) => {
        langFlag.set(code)
    }

    const getLang = (lowerFormat = false) => {
        return lowerFormat ? langFlag.get().replace("-", "_") : langFlag.get()
    }

    const getLangInfo = () => {
        return {
            code: langFlag.get(),
            name: __(langFlag.get()),
            nameShort: __(langFlag.get() + '-short')
        }
    }

    const getLangDefault = (lowerFormat = false) => {
        return lowerFormat
            ? localLangDefault.replace("-", "_")
            : localLangDefault
    }

    // de_DE => de, en_GB => en
    const getLangShort = () => {
        return getLang().split("-")[0]
    }

    const getLangList = () => {
        return localLangList
            .map(lang => {
                return {code: lang, name: __(lang)}
            })
            .sort(function (a, b) {
                if (a.name < b.name) return -1
                if (a.name > b.name) return 1
                return 0
            })
    }

    const __ = (text, replacements = null) => {
        if (!text) return ""
        if (!text.trim()) return ""

        const item = state?.api?.[text] || state?.app?.[text]
        let langLabel = item?.[getLang()]
            ? item[getLang()]
            : item?.[getLangDefault()]
                ? item[getLangDefault()]
                : (localTranslationMissingPrefix + text)

        if (replacements) {
            return langLabel.replace(/%(\w+)%/g, (match, p1) => replacements[p1] ?? match)
        }

        return langLabel
    }

    const getLabel = (langLabels) => {
        if (typeof langLabels === 'object') {
            if (langLabels[getLang(true)]) return langLabels[getLang(true)]
            if (langLabels[getLangDefault(true)]) return langLabels[getLangDefault(true)]
            return (localTranslationMissingPrefix + Object.values(langLabels)[0])
        }

        return __(langLabels)
    }

    const decimal = (value) => {
        return new Intl.NumberFormat(getLang(), localFormatDecimal).format(value)
    }
    const currency = (value) => {
        return new Intl.NumberFormat(getLang(), localFormatCurrency).format(value)
    }
    const currencyPlain = (value) => {
        return new Intl.NumberFormat(getLang(), localFormatCurrencyShort).format(value)
    }
    const datetime = (value) => {
        return new Intl.DateTimeFormat(getLang(), localDateTimeOptions).format(new Date(value))
    }
    const date = (value) => {
        return new Intl.DateTimeFormat(getLang(), localDateOptions).format(new Date(value))
    }

    return {
        load,
        setLang,
        getLang,
        getLangDefault,
        getLangShort,
        getLangInfo,
        getLangList,
        decimal, currency, currencyPlain, date, datetime,
        __, getLabel,
    }
}
